import React from "react";
import styles from "./AppPrivacyPolicy.module.css";

const AppPrivacyPolicy = () => {
  const today = new Date().toLocaleDateString("en-IN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <main className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <p className={styles.eyebrow}>BUDDYx App Policy</p>
          <h1>Privacy Policy for BUDDYx</h1>
          <p className={styles.heroText}>
            We are committed to protecting student privacy and being transparent
            about data handling in our educational coding app.
          </p>
          <p className={styles.updatedAt}>Last Updated: {today}</p>
        </div>
      </section>

      <section className={styles.contentWrap}>
        <aside className={styles.quickNav}>
          <h2>Quick Navigation</h2>
          <a href="#introduction">1. Introduction</a>
          <a href="#children-privacy">2. Children&apos;s Privacy &amp; COPPA</a>
          <a href="#permissions">3. Permissions and Data Collection</a>
          <a href="#sharing">4. Data Sharing and Third Parties</a>
          <a href="#security">5. Data Security</a>
          <a href="#parental-rights">6. Parental Rights</a>
          <a href="#contact-us">7. Contact Us</a>
        </aside>

        <article className={styles.policyCard}>
          <section id="introduction">
            <h2>1. Introduction</h2>
            <p>
              At StemX India, we are committed to protecting the privacy of our
              users, especially students and children. This Privacy Policy
              explains how we handle information in the BUDDYx mobile
              application, which is designed as a block-based coding companion
              for the PraniX Core microcontroller.
            </p>
          </section>

          <section id="children-privacy">
            <h2>2. Children&apos;s Privacy &amp; COPPA Compliance</h2>
            <p>BUDDYx is designed for students in Grades 1-10.</p>
            <p>
              <strong>No Personal Information:</strong> We do not collect, store,
              or solicit any personally identifiable information (PII) from
              children, including names, email addresses, phone numbers, or
              physical addresses.
            </p>
            <p>
              <strong>Compliance:</strong> This app is developed in compliance
              with the Children&apos;s Online Privacy Protection Act (COPPA) and
              the Google Play Families Policy.
            </p>
          </section>

          <section id="permissions">
            <h2>3. Permissions and Data Collection</h2>
            <p>
              To provide the core functionality of the app, BUDDYx may request
              the following permissions:
            </p>
            <h3>Approximate Location (Bluetooth/Wi-Fi Scanning)</h3>
            <p>
              Android requires Approximate Location permission to scan for and
              connect to nearby Bluetooth or Wi-Fi devices. BUDDYx uses this
              permission strictly to discover and pair with your PraniX Core
              board.
            </p>
            <h3>Ephemeral Processing</h3>
            <p>
              Location data is processed temporarily in real time for hardware
              discovery purposes only. This data is never stored on our servers
              or shared with third parties.
            </p>
            <h3>Device Information</h3>
            <p>
              We may access limited, non-identifiable device information (such
              as operating system version) to ensure the coding blocks render
              correctly on your device.
            </p>
          </section>

          <section id="sharing">
            <h2>4. Data Sharing and Third Parties</h2>
            <p>
              <strong>No Advertising:</strong> BUDDYx contains no advertisements
              and does not use data for behavioral advertising.
            </p>
            <p>
              <strong>No Third-Party Analytics:</strong> We do not share user
              data with third-party analytics or marketing services.
            </p>
          </section>

          <section id="security">
            <h2>5. Data Security</h2>
            <p>
              We prioritize the security of your interaction with our hardware.
              All communication between the BUDDYx app and the PraniX Core board
              is encrypted during transmission.
            </p>
          </section>

          <section id="parental-rights">
            <h2>6. Parental Rights</h2>
            <p>
              Parents have the right to inquire about the information accessed by
              the app. Since we do not store personal data on our servers, there
              is no account data to delete. However, app permissions can be
              managed and local app cache can be cleared through your device
              settings at any time.
            </p>
          </section>

          <section id="contact-us">
            <h2>7. Contact Us</h2>
            <p>
              If you have any questions regarding this Privacy Policy or our
              privacy practices, please contact our Child Safety Point of
              Contact:
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:info@stemxindia.com">info@stemxindia.com</a>
            </p>
            <p>
              <strong>Website:</strong>{" "}
              <a
                href="https://edu.stemxindia.com/"
                target="_blank"
                rel="noreferrer"
              >
                https://edu.stemxindia.com/
              </a>
            </p>
          </section>
        </article>
      </section>
    </main>
  );
};

export default AppPrivacyPolicy;
